const avail = (p, color, size) => p.variants.some((v) => v.color === color && (!size || v.size === size) && v.is_available !== false);

export const unavailableColors = (p) => (p.variants?.length ? p.colors.filter((c) => !avail(p, c.name)).map((c) => c.name) : []);

export const firstColor = (p) => p.colors?.find((c) => !unavailableColors(p).includes(c.name))?.name || p.colors?.[0]?.name;

export const ColorPicker = ({ colors, value, onChange, unavailable = [] }) => (
  <div>
    <p className="text-sm font-semibold text-navy mb-2">
      Color: <span className="font-normal text-navy/70">{value}</span>
      {unavailable.includes(value) && <span className="ml-2 text-sunset font-semibold" data-testid="color-unavailable-note">Unavailable</span>}
    </p>
    <div className="flex flex-wrap gap-2.5">
      {colors.map((c) => {
        const off = unavailable.includes(c.name);
        return (
          <button
            key={c.name}
            onClick={() => onChange(c.name)}
            disabled={off}
            title={off ? `${c.name} – unavailable` : c.name}
            aria-label={off ? `${c.name} (unavailable)` : c.name}
            aria-pressed={value === c.name}
            className={`relative w-10 h-10 rounded-full border border-navy/15 transition-shadow overflow-hidden disabled:opacity-35 disabled:cursor-not-allowed ${value === c.name ? "ring-2 ring-offset-2 ring-turq" : "hover:ring-2 hover:ring-offset-2 hover:ring-navy/20"}`}
            style={{ background: c.hex }}
            data-testid={`color-option-${c.name.toLowerCase().replace(/\s+/g, "-")}`}
          >
            {off && <span className="absolute left-1/2 top-[-4px] h-12 w-0.5 bg-white rotate-45 shadow-[0_0_0_1px_rgba(10,37,64,0.85)]" aria-hidden="true" />}
          </button>
        );
      })}
    </div>
  </div>
);

export const unavailableSizes = (p, color) => (p.variants?.length ? p.sizes.filter((s) => !avail(p, color, s)) : []);

export const SizePicker = ({ sizes, value, onChange, unavailable = [] }) => (
  <div className="flex flex-wrap gap-2">
    {sizes.map((s) => (
      <button
        key={s}
        onClick={() => onChange(s)}
        disabled={unavailable.includes(s)}
        aria-pressed={value === s}
        className={`min-w-12 h-12 px-3 rounded-full border-2 font-semibold transition-colors disabled:opacity-30 disabled:line-through disabled:cursor-not-allowed ${value === s ? "border-navy bg-navy text-white" : "border-border text-navy hover:border-navy"}`}
        data-testid={`size-option-${s.toLowerCase().replace(/\s+/g, "-")}`}
      >
        {s}
      </button>
    ))}
  </div>
);
